var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaidSocialAdvertisingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Paid Social Advertising Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 24 L24 16 V48 L8 40 Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16 L48 32 L24 48",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 32,
    r: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 32,
    r: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 32,
    x2: 58,
    y2: 22
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58,22 56,22 54,20 56,18",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidSocialAdvertisingIcon);
export default __webpack_public_path__ + "static/media/paid-social-advertising-icon.230ac781d075d01567aa621c36357c9b.svg";
export { ForwardRef as ReactComponent };